// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Dq-z","imageAndVideoCount":"Eq-z","imageAndVideoContainer":"Fq-z","viewAllReviews":"Gq-z"};